"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _typed = require('shared/hooks/typed');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _entities = require('shared/transforms/entities');
var _uuid = require('shared/services/uuid');

// Enough for a practice's roster; search finds anyone beyond it.
 const STAFF_LIMIT = 200; exports.STAFF_LIMIT = STAFF_LIMIT

const EMPTY_STAFF = []

/* The New chat's "Staff": your coworkers in the chat's practice, by name,
 * each described by the practice's name. Loaded once per practice. */
 const useOrgStaff = (orgKey) => {
  const orgs = _typed.useAppSelector.call(void 0, _org.selectOrgs)
  const myUserKey = _typed.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const [users, setUsers] = _react.useState(null)
  const isValid = !!orgKey && orgKey !== _uuid.EMPTY_BLUID

  _react.useEffect.call(void 0, () => {
    if (!isValid) return
    let isCurrent = true
    _actions2.default.findUsersInOrg({ OrgKey: orgKey, Limit: exports.STAFF_LIMIT })
      .then(res => { if (isCurrent) setUsers({ orgKey, list: _optionalChain([res, 'optionalAccess', _ => _.Users]) || [] }) })
      .catch(() => { if (isCurrent) setUsers({ orgKey, list: [] }) })
    return () => { isCurrent = false }
  }, [orgKey, isValid])

  const orgName = (orgKey && _optionalChain([(orgs ), 'optionalAccess', _2 => _2[orgKey], 'optionalAccess', _3 => _3.Name])) || ''
  const staffList = _react.useMemo.call(void 0, () => {
    if (!users || users.orgKey !== orgKey) return EMPTY_STAFF
    const toEntity = _entities.mapUserToEntity.call(void 0, orgs , () => orgName)
    return users.list
      .filter(user => user.UserKey !== myUserKey)
      .map(toEntity)
      .sort((a, b) => a.name.localeCompare(b.name))
  }, [users, orgKey, orgs, orgName, myUserKey])

  return { staffList, isLoading: isValid && _optionalChain([users, 'optionalAccess', _4 => _4.orgKey]) !== orgKey }
}; exports.useOrgStaff = useOrgStaff
